export default __webpack_public_path__ + "static/media/designTask.0ee07c6a.svg";